import React from "react";
import { isLetters } from "./validationFormHandler";

export function getCookie(name: string) {
    const match = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
    );
    // console.log('match Cookie: ', match[1]);
    return match ? decodeURIComponent(match[1]) : undefined;
}

export async function hashStringSHA1Client(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await window.crypto.subtle?.digest("SHA-1", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

export function getGaClientId(): string {
  let ga = document.cookie.match(/_ga=[^;]*/)?.[0]; 
  return ga ? ga.replace('_ga=GA1.1.', '') : '';
}

export function extractErrorCode(message: string): string {
    let text = message;
    if(text.includes('*')){
        text = text.slice(0, text.indexOf('*'));
    }
    return text;
}

export function extractErrorMessageCode(message: string, sliceEnd?: string): string {
    let text = message;
    if(text.includes('*')){
        text = text.slice(text.indexOf('*')+1);
        if(sliceEnd && text.includes(sliceEnd)){
            text = text.slice(0, text.indexOf(sliceEnd));
        }
    }
    return text;
}

export function setDefaultErrors(errors: any): any {
    let values = Object.values(errors);
    
    values.forEach(val => {
        val['passed_validation'] = false; 
        val['message'] = val['jsx_element'] ? {element: React.createElement(React.Fragment, null), text: ''} : ''
    });

    return errors;
}

export function chunkArray(array: any[], size: number) : any[][] {
    const resultingArray: any[] = [];
    for(let i = 0; i < array.length; i += size){
        resultingArray.push(array.slice(i, i + size));
    }
    return resultingArray;
}

export function colorYiq(color: string) {

    if (isLetters(color)) {
        color = colorNameToHex(color);
        // colorNameToHex(color).then(res => {console.log(res); return determineTextColor(res)});
        return determineTextColor(color);
    } else {
        // console.log('color: ', color)
        return determineTextColor(color);
    }

}

function colorNameToHex(color: string) {
    const element = document.createElement('div');
    element.style.color = color;
    document.body.appendChild(element);

    const computed = getComputedStyle(element).color;
    // console.log('computed: ', computed);
    document.body.removeChild(element);

    const [r, g, b] = computed.match(/\d+/g).map(Number);
    // console.log('rgb: ', [r, g, b])
    const hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    // console.log('hex: ', hex);
    return hex;
}

function determineTextColor(color: string) {
    if(!color) return; 
    // console.log('determine: ', color);
    if (color.startsWith('#')) {
        color = color.slice(1);
        if (color.length === 3) {
            color = color.split('').map(c => c + c).join('');
        }
    }

    const r = parseInt(color.slice(0, 2), 16);
    const g = parseInt(color.slice(2, 4), 16);
    const b = parseInt(color.slice(4), 16);

    // Calculate YIQ value
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    // console.log('yiq: ', yiq);

    // Return black for light colors, white for dark colors
    return yiq >= 128 ? 'black' : 'white';
}

export function bodyDisableScroll(trigger: boolean) {
    trigger 
    ?
    document.body.style.overflow = 'hidden'
    :
    document.body.style.overflow = 'auto'
}

export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}